import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';
import { CampaignReportData } from '../../../types/campaignReport';
import { formatPercent, formatCurrencyGBP } from '../../../lib/reportFormatters';
import { TrendingUp } from 'lucide-react';

interface HaloTabProps {
  data: CampaignReportData;
}

export function HaloTab({ data }: HaloTabProps) {
  return (
    <div className="space-y-8">
      {/* Store Halo Effect Table */}
      <Card style={{ boxShadow: '0 4px 6px -1px rgba(24, 61, 247, 0.3), 0 2px 4px -1px rgba(24, 61, 247, 0.18)' }}>
        <CardHeader>
          <CardTitle className="text-xl font-bold" style={{ color: '#183df7' }}>
            6️⃣ Store Halo Effect
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="font-semibold">Metric</TableHead>
                <TableHead className="text-right font-semibold">Impact</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell className="font-medium">Footfall Uplift</TableCell>
                <TableCell className="text-right font-semibold" style={{ color: '#183df7' }}>
                  +{formatPercent(data.halo.footfallUplift)} vs prior 6-month baseline
                </TableCell>
              </TableRow>
              {data.halo.giftCardRedemption && (
                <TableRow>
                  <TableCell className="font-medium">Gift Card Redemption In-Store</TableCell>
                  <TableCell className="text-right font-semibold" style={{ color: '#183df7' }}>
                    {formatPercent(data.halo.giftCardRedemption)} of machine buyers
                  </TableCell>
                </TableRow>
              )}
              {data.halo.sameDayCrossPurchase && (
                <TableRow>
                  <TableCell className="font-medium">Same-Day Cross Purchase</TableCell>
                  <TableCell className="text-right font-semibold" style={{ color: '#183df7' }}>
                    {formatPercent(data.halo.sameDayCrossPurchase)}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className="font-medium">Estimated Incremental Store Revenue</TableCell>
                <TableCell className="text-right font-semibold" style={{ color: '#183df7' }}>
                  {formatCurrencyGBP(data.halo.estimatedIncrementalStoreRevenue)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      {/* Impact Highlight Card */}
      <Card 
        className="border-2"
        style={{ 
          boxShadow: '0 4px 6px -1px rgba(24, 61, 247, 0.3), 0 2px 4px -1px rgba(24, 61, 247, 0.18)',
          borderColor: '#183df7',
          background: 'linear-gradient(135deg, rgba(24, 61, 247, 0.05) 0%, rgba(24, 61, 247, 0.1) 100%)'
        }}
      >
        <CardContent className="p-8 text-center">
          <TrendingUp className="w-12 h-12 mx-auto mb-4" style={{ color: '#183df7' }} />
          <p className="text-sm font-medium text-muted-foreground mb-2">Footfall Uplift vs. Prior 6-Month Baseline</p>
          <p className="text-5xl font-bold mb-2" style={{ color: '#183df7' }}>
            +{formatPercent(data.halo.footfallUplift)}
          </p>
          <p className="text-sm text-muted-foreground">Measurable store halo effect</p>
        </CardContent>
      </Card>
    </div>
  );
}
